import React from 'react';
import { BurgerBtnSvg, InstagramSvg, TelegramSvg } from '../../SVGComponents/SVGComponents';
import styles from './TopBlock.module.css';

export default function TopBlock({ toggleMenu }) {
  return (
    <div className={styles.top_block}>
      <div className={styles.contacts_wrapper}>
        <a
          href="https://t.me/+380968513108"
          target="_blank"
          rel="noopener noreferrer"
          className="h30 hover active activeClick">
          <TelegramSvg />
        </a>
        <a
          href="https://www.instagram.com/natalya_kylish"
          target="_blank"
          className="h30 hover active activeClick"
          rel="noopener noreferrer">
          <InstagramSvg />
        </a>
        <a href="tel:+380968513108" className={styles.call_btn + ' ' + 'hover active activeClick'}>
          096 851 31 08
        </a>
      </div>
      <button className="hover active activeClick" onClick={() => toggleMenu(true)}>
        <BurgerBtnSvg />
      </button>
    </div>
  );
}
